import { forIn } from "lodash-es";
import $ from "jquery";
import videojs from "./lib/video.js";
import "./lib/videojs-youtube";
import "./lib/videojs-vimeo";
import "./lib/videojs-wistia";
import "./lib/videojs-markers";
import "./a11yPlugin";

import shared from "./js/_shared";
import knowblyAudio from "./js/knowbly-audio";
import knowblyVideo from "./js/knowbly-video";

import "./css/knowbly-videojs.scss";

export VideoJS from "./VideoJS.vue";

/*
 * WRAPPER FOR VIDEOJS ELEMENTS
 */
buildComponent("wrapperComponent", "Component", {
    createEl: function() {
        return videojs.dom.createEl("div", {
            className: this.options_.className || "vjs-wrapper",
        });
    },
});
/**
 * END OF WRAPPER
 */

function resetMedias() {
    forIn(shared.videoStack, (value, key) => {
        shared.videoStack[key].reset().initChildren();
    });

    forIn(shared.audioStack, (value, key) => {
        shared.audioStack[key].currentTime(0).pause();
    });
}

async function destroyVideoJS({ container }) {
    const promises = [];

    $(container)
        .find("div.video-js")
        .each((i, el) => {
            if (el.player) {
                promises.push(shared._disposePlayer({ videojs, player: el.player }));
            }
        });

    await Promise.all(promises);
}

async function startVideoJS({
    container,
    isEdit = false,
    fromFroala = isEdit,
    scorm = false,
    disableFullScreen = false,
    onFullscreenChange = null,
    filestack = null,
    isExport = false,
    getDynamicMediaData,
    getAssetA11y,
    onProgress,
    getFlags,
} = {}) {
    if (container) {
        container = container.length ? container : $(container);
        const promises = [];

        $(container)
            .find("video.video-js")
            .each((ix, el) => {
                promises.push(
                    knowblyVideo({
                        videojs,
                        container,
                        el,
                        isEdit,
                        fromFroala,
                        disableFullScreen,
                        scorm,
                        onFullscreenChange,
                        filestack,
                        isExport,
                        getDynamicMediaData,
                        getAssetA11y,
                        onProgress,
                        getFlags,
                    }),
                );
            });

        $(container)
            .find("audio.video-js")
            .each((ix, el) => {
                promises.push(
                    knowblyAudio({
                        videojs,
                        container,
                        el,
                        isEdit,
                        fromFroala,
                        filestack,
                        isExport,
                        getDynamicMediaData,
                        getAssetA11y,
                        onProgress,
                        getFlags,
                    }),
                );
            });

        let playersStarted = [];
        await Promise.all(promises).then(players => {
            playersStarted = players;
        });

        return {
            videoStack: shared.videoStack,
            audioStack: shared.audioStack,
            playersStarted,
        };
    } else {
        console.error("Video container is undefined");
    }
}

export function startVideoJSHOF(staticParams) {
    return params => {
        return startVideoJS({
            ...params,
            ...staticParams,
        });
    };
}

export function buildComponent(name, type, videojsOptions, attrs = {}) {
    const Component = videojs.getComponent(type);
    const customComponent = videojs.extend(Component, {
        ...videojsOptions,
    });
    if (attrs.title) {
        customComponent.prototype.controlText_ = attrs.title;
    }
    videojs.registerComponent(name, customComponent);
}

export default {
    startVideoJS,
    destroyVideoJS,
    pauseMedias: shared._pauseMedias.bind(shared),
    resetMedias,
    videojs,
    vjsEncode: shared._vjsEncode.bind(shared),
    disposePlayer: shared._disposePlayer.bind(shared),
};

export { videojs };
